import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type {
  GetSoftwareLicenseSubGroupsParams,
  GetSoftwareUserGroupsParams,
  UpdateSoftwareArchitectureReq,
  UpdateSoftwareDetailReq,
} from './type';

export const getSoftware = async (softwareId: string) => {
  const res = await apiClient.GET('/v2/software/{softwareId}', {
    params: { path: { softwareId } },
  });
  return getDataOrThrowApiError(res);
};

export const updateSoftwareDetail = async (
  softwareId: string,
  data: UpdateSoftwareDetailReq,
) => {
  const res = await apiClient.PUT('/v2/software/{softwareId}/detail', {
    params: { path: { softwareId } },
    body: data,
  });
  return getDataOrThrowApiError(res);
};

export const updateSoftwareArchitecture = async (
  softwareId: string,
  data: UpdateSoftwareArchitectureReq,
) => {
  const res = await apiClient.PUT('/v2/software/{softwareId}/architecture', {
    params: { path: { softwareId } },
    body: data,
  });
  return getDataOrThrowApiError(res);
};

export const getSoftwareLicenseSubGroups = async (
  softwareId: string,
  search: GetSoftwareLicenseSubGroupsParams,
) => {
  const res = await apiClient.GET(
    '/v2/software/{softwareId}/license-subgroups',
    {
      params: {
        path: { softwareId },
        query: search,
      },
    },
  );
  return getDataOrThrowApiError(res);
};

export const getSoftwareUserGroups = async (
  softwareId: string,
  search: GetSoftwareUserGroupsParams,
) => {
  const res = await apiClient.GET('/v2/software/{softwareId}/user-groups', {
    params: {
      path: { softwareId },
      query: search,
    },
  });
  return getDataOrThrowApiError(res);
};

// ロゴ関連のAPI関数
export const getSoftwareLogoPresignedUrl = async (softwareId: string) => {
  const res = await apiClient.GET(
    '/v2/software/{softwareId}/logo/presigned-url',
    {
      params: { path: { softwareId } },
    },
  );
  return getDataOrThrowApiError(res);
};

export const uploadSoftwareLogo = async (presignedUrl: string, file: File) => {
  const response = await fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  if (!response.ok) {
    throw new Error(`Logo upload failed: ${response.statusText}`);
  }

  return response;
};

export const deleteSoftwareLogo = async (presignedUrl: string) => {
  const response = await fetch(presignedUrl, {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error(`Logo delete failed: ${response.statusText}`);
  }

  return response;
};
